import { Command } from '@ckeditor/ckeditor5-core';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

const PLUGIN_NAME = 'CustomButtonDecisionText';

// ******************************************
//     テキスト確定（ボタン）
// ******************************************
export class CustomButtonDecisionText extends Plugin {
  static get pluginName() {
    return PLUGIN_NAME;
  }

  init() {
    const editor = this.editor;

    // コマンド登録
    editor.commands.add(`${PLUGIN_NAME}:execute`, new CustomButtonDecisionTextExecuteCommand(editor));

    editor.ui.componentFactory.add('customButtonDecisionText', () => {
      const button = new ButtonView();

      // ボタン
      button.set({ label: editor.i18n.t('テキスト確定'), withText: true });

      // ボタン有効／無効
      button.bind('isEnabled').to(this.editor, 'isReadOnly', (value) => !value);

      // クリック時の処理
      button.on('execute', () => {
        this.execute(editor);
      });
      return button;
    });
  }
  execute(ed) {
    const keyword = 'ps_no';
    ed.model.change((writer) => {
      const selection = ed.model.document.selection;
      const blocks = [...selection.getSelectedBlocks()];

      // ブロック要素： div, p, h1～h5
      const blockElements = {
        htmlDiv: 'htmlDivAttributes',
        htmlDivParagraph: 'htmlDivAttributes',
        paragraph: 'htmlPAttributes',
        heading1: 'htmlH1Attributes',
        heading2: 'htmlH2Attributes',
        heading3: 'htmlH3Attributes',
        heading4: 'htmlH4Attributes',
        heading5: 'htmlH5Attributes',
        heading6: 'htmlH6Attributes',
        table: 'htmlTableAttributes',
        imageBlock: 'htmlFigureAttributes',
        paragraphSupplementSubhead: 'htmlPAttributes',
        paragraphSupplementPara: 'htmlPAttributes',
        paragraphReferGear: 'htmlPAttributes',
        paragraphRefer: 'htmlPAttributes',
        allColumnIllust: 'htmlPAttributes',
        paragraphBlank: 'htmlPAttributes',
        verbatim: 'htmlPAttributes',
        warningListTitle: 'htmlPAttributes',
        illustHeadline: 'htmlPAttributes',
      };

      // タグを遡ってps_noがあるタグまで移動
      // 仮にps_noが空だったり@@@の場合、対象のelementを返す。判別するためにkeyはnullにする。
      var searchPs = function (element) {
        for (const [key, attr] of element._attrs) {
          if (attr.attributes && keyword in attr.attributes) {
            if (attr.attributes.ps_no == '') {
              return [element, key, true];
            }
            if (attr.attributes.ps_no == '@@@') {
              return [element, key, true];
            }
            return [element, key, false];
          } else {
            // console.log('keyword なし')
          }
        }
        if (!element.parent) return [null, null, true];
        return searchPs(element.parent);
      };

      // 日付フォーマット
      var formatDate = (date, sep = '') => {
        const yyyy = date.getFullYear();
        const mm = ('00' + (date.getMonth() + 1)).slice(-2);
        const dd = ('00' + date.getDate()).slice(-2);
        return `${yyyy}${sep}${mm}${sep}${dd}`;
      };

      // 現在選択中のタグを確認
      var [selectElement, attrName, noPs] = searchPs(blocks[0]);

      // テキスト確定属性値用の変数
      let jsonData = null;

      // -----------------------------------------------------------------------------------
      // PSではない
      // -----------------------------------------------------------------------------------

      if (!selectElement) {
        // PSではない
        selectElement = blocks[0];
        const attrKey = blockElements[selectElement.name]; // 属性キー

        // デフォルトは確定
        let attrData = { attributes: { confirmed: '3' } };

        // 属性によって処理を分岐
        if (!selectElement.getAttribute(attrKey)) {
          // 属性値を持たない
          // jsonData = JSON.stringify(attrData);
          jsonData = attrData;
        } else if (!selectElement.getAttribute(attrKey).attributes) {
          // 属性値を持たない
          // jsonData = JSON.stringify(attrData);
          jsonData = attrData;
        } else if (!selectElement.getAttribute(attrKey).attributes.confirmed) {
          // confirmed属性が無い場合、confirmed属性を追加
          jsonData = JSON.parse(JSON.stringify(selectElement.getAttribute(attrKey)));
          jsonData.attributes.confirmed = '3';
        } else if (
          selectElement.getAttribute(attrKey).attributes.confirmed === '0' ||
          selectElement.getAttribute(attrKey).attributes.confirmed === '2'
        ) {
          // 未確定 ⇒ 確定    ※ 0は今後使わないが、旧仕様には属性値として0が入っている
          jsonData = JSON.parse(JSON.stringify(selectElement.getAttribute(attrKey)));
          jsonData.attributes.confirmed = '3';
        } else if (
          selectElement.getAttribute(attrKey).attributes.confirmed === '1' ||
          selectElement.getAttribute(attrKey).attributes.confirmed === '3'
        ) {
          // 確定 ⇒ 未確定    ※ 1は今後使わないが、旧仕様には属性値として1が入っている
          jsonData = JSON.parse(JSON.stringify(selectElement.getAttribute(attrKey)));
          jsonData.attributes.confirmed = '2';
        }

        // 属性値が設定出来たら反映する
        if (jsonData) {
          // title属性値があれば削除
          if (jsonData.attributes.title) {
            delete jsonData.attributes.title;
          }
          writer.setAttribute(attrKey, jsonData, selectElement);
        }
        return;
      }

      // -----------------------------------------------------------------------------------
      // PSが存在する
      // -----------------------------------------------------------------------------------

      // 現在日付
      const dateTime = new Date();
      const date = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
      const ymd = formatDate(date, '/');

      if (!selectElement.getAttribute(attrName).attributes.confirmed) {
        // confirmed属性が無い場合、confirmed属性を追加
        jsonData = JSON.parse(JSON.stringify(selectElement.getAttribute(attrName)));
        // 確定
        jsonData.attributes.confirmed = noPs ? '3' : '1';
        // title属性値
        const psNo = jsonData.attributes.ps_no;
        jsonData.attributes.title = `Fixed : ${psNo} ${ymd}`;
      } else if (
        selectElement.getAttribute(attrName).attributes.confirmed === '0' ||
        selectElement.getAttribute(attrName).attributes.confirmed === '2'
      ) {
        // 未確定 ⇒ 確定
        jsonData = JSON.parse(JSON.stringify(selectElement.getAttribute(attrName)));
        // 確定
        jsonData.attributes.confirmed = noPs ? '3' : '1';
        // title属性値
        const psNo = jsonData.attributes.ps_no;
        jsonData.attributes.title = `Fixed : ${psNo} ${ymd}`;
      } else if (
        selectElement.getAttribute(attrName).attributes.confirmed === '1' ||
        selectElement.getAttribute(attrName).attributes.confirmed === '3'
      ) {
        // 確定 ⇒ 未確定
        jsonData = JSON.parse(JSON.stringify(selectElement.getAttribute(attrName)));
        // 確定
        jsonData.attributes.confirmed = noPs ? '2' : '0';
        // title属性値
        const psNo = jsonData.attributes.ps_no;
        jsonData.attributes.title = `Pending : ${psNo}`;
      }

      // 属性値が設定出来たら反映する
      if (jsonData) {
        if (jsonData.attributes.title && noPs) {
          // title属性値があり、PSではない場合、title属性値は削除する
          delete jsonData.attributes.title;
        }
        writer.setAttribute(attrName, jsonData, selectElement);
      }

      // paElement以下のnodeにconfirmed属性が存在すれば削除する（再回帰）
      var delConfirmed = function (writer, paElement) {
        if (!paElement) return;
        if (paElement._children && paElement._children._nodes.length > 0) {
          // 子要素あり
          paElement._children._nodes.forEach((chElement) => {
            const keyword = 'confirmed';
            for (const [key, attr] of chElement._attrs) {
              if (attr.attributes && keyword in attr.attributes) {
                // confirmed属性が存在する場合、削除
                const copiedAttributes = JSON.parse(JSON.stringify(attr));
                delete copiedAttributes.attributes.confirmed; // confirmed属性を削除

                console.log('テキスト確定（PS Divの子要素からconfirmed属性を削除）');
                console.log(key);
                console.log(copiedAttributes);

                // 属性値更新
                writer.setAttribute(key, copiedAttributes, chElement);
              }
            }
            delConfirmed(writer, chElement);
          });
        }
        return;
      };
      // ps_no属性が存在する場合、その中のブロック要素にあるconfirmed属性を削除する（重なるので）
      delConfirmed(writer, selectElement);
    });

    // ここからckEditorAdapterの関数を実行
    const config = ed.config.get('decisionText');
    const runPlugin = config.runPlugin;
    runPlugin();
  }
}

class CustomButtonDecisionTextExecuteCommand extends Command {
  execute() {
    const editor = this.editor;

    const instance = new CustomButtonDecisionText();
    instance.execute(editor);
  }
}
